import { type CSSObject } from '@emotion/react';
import { useTheme } from '@doxyme/ui-foundation/theme';

type Props = {
  videoEl?: HTMLVideoElement | HTMLElement;
  isBackgroundBlurry: boolean;
  objectFit: 'cover' | 'contain' | 'none';
  backgroundImage?: string;
};

type Return = Record<'container' | 'video', CSSObject>;

export const useVideoPreviewStyles = ({
  videoEl,
  isBackgroundBlurry,
  objectFit,
  backgroundImage,
}: Props): Return => {
  const theme = useTheme();

  return {
    container: {
      position: 'relative',
      display: videoEl ? 'block' : 'none',
      lineHeight: 0,
      height: '100%',
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        background:
          backgroundImage !== undefined
            ? `url(${backgroundImage}) center /cover`
            : theme.palette.background.default,
        ...(isBackgroundBlurry && {
          filter: 'blur(100px)',
          // BROWSER: helps Safari render the filter properly
          transform: 'translate3d(0, 0, 0)',
        }),
      },
    },
    video: {
      width: '100%',
      height: '100%',
      objectFit: objectFit,
      transform: 'rotateY(180deg)',
    },
  };
};
